import { render, staticRenderFns } from "./TambahPembelian.vue?vue&type=template&id=0dad87a4&"
import script from "./TambahPembelian.vue?vue&type=script&lang=js&"
export * from "./TambahPembelian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports